<template>

<v-menu offset-y  transition="scroll-y-transition">
  <template v-slot:activator="{ on }">
    <v-btn v-on="on"
    >
      Dropdown
      <v-icon right>mdi-triangle-small-down</v-icon>
    </v-btn>
  </template>
  <v-list >
    <v-list-item v-for="menu in menus" :key="menu.no" link>
      <v-list-item-title class="text_right">{{ menu.name }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>

</template>

<script>
export default {
  name: "ComputedCalculation",

data() {
  return {
    menus: [{no:1, name:'ログアウト', icon:'mdi-clipboard-account'}]
  }
},
computed: {
  totalMarks() {
    return this.number * 3;
  }
}
};

</script>

